import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    {
      index: true,
      lazy: page(() => import("./HomePage")),
      handle: shows("captures", "progression", "feed", "market", "notifications"),
    },
    { path: "discoveries", lazy: page(() => import("./DiscoveriesPage")), handle: shows("feed") },
  ],
};
